<template>
  <el-tabs
    v-model="tabActive"
    type="card"
    style="margin-top: 10px;"
  >
    <el-tab-pane
      :lazy="true"
      label="FAQ"
      name="faq"
    >
      <el-form
        :model="formData"
        inline
      >
        <el-form-item style="padding: 0 10px">
          <el-input
            v-model="faqMessage"
            :clearable="true"
            style="width: 400px;"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            > </i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            @click="handlerFaqSubmit"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <ul style="list-style: none; text-align: left">
        <li
          v-for="(faq,k) in faqList"
          :key="k"
        >
          {{ faq }}
          <el-button
            size="mini"
            type="primary"
            @click="handlerActiveFaq(faq)"
          >
            应用
          </el-button>
        </li>
      </ul>
    </el-tab-pane>
    <el-tab-pane
      :lazy="true"
      label="控件"
      name="widget"
    >
      <el-collapse
        v-model="currentScript"
        style="margin: 10px;"
        accordion
      >
        <el-collapse-item
          v-for="(key, name) in scripts"
          :key="key"
          :title="name"
          :name="key"
        >
          <el-button
            size="mini"
            type="primary"
            @click="handlerScriptGo(key)"
          >
            GO
          </el-button>
        </el-collapse-item>
      </el-collapse>
    </el-tab-pane>
    <el-tab-pane
      :lazy="true"
      label="方案"
      name="plan"
    >
      <plan
        :user-id="userId"
      />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
  import request from '../../../api/request'
  import Plan from './Plan'

  export default {
    name: 'CustomServiceTools',
    components:{
      Plan
    },
    props: {
      userId: {
        type: Number,
        default: 0
      },
      userMessage: {
        type: String,
        default: ''
      },
      faqList: {
        type: Array,
        default: () => []
      }
    },
    data: function () {
      return {
        tabActive: 'faq',
        faqMessage: '',
        formData: {},
        scripts: {},
        currentScript: ''
      }
    },
    watch: {
      userMessage: function () {
        this.faqMessage = this.userMessage
      },
      userId: function () {
        this.getScriptNames()
        this.tabActive = 'faq'
      },
    },
    created: function () {
      if (this.userId) {
        this.getScriptNames()
      }
    },
    methods: {
      handlerFaqSubmit: function () {
        this.$emit('searchFaq', this.faqMessage)
      },
      handlerActiveFaq: function (faq) {
        this.$emit('activeFaq', faq)
      },
      handlerScriptGo: function (script) {
        this.$emit('scriptGo', script)
      },
      getScriptNames: function () {
        request.front.post('user_get_script_name_list', {
          uid: this.userId
        }).then(resp => {
          this.scripts = resp.data
        })
      },
    }
  }
</script>